// store/adminConfig.actionTypes.js

// ================================INITIAL DATA FETCH ================================ //
export const FETCH_CONFIG_DATA_START = 'FETCH_CONFIG_DATA_START';
export const FETCH_CONFIG_DATA_SUCCESS = 'FETCH_CONFIG_DATA_SUCCESS';
export const FETCH_CONFIG_DATA_FAILURE = 'FETCH_CONFIG_DATA_FAILURE';

// ================================COLLEGE COURSE MAPPING - ASYNC ================================ //
export const CREATE_COLLEGE_COURSE_MAPPING_START = 'CREATE_COLLEGE_COURSE_MAPPING_START';
export const CREATE_COLLEGE_COURSE_MAPPING_SUCCESS = 'CREATE_COLLEGE_COURSE_MAPPING_SUCCESS';
export const CREATE_COLLEGE_COURSE_MAPPING_FAILURE = 'CREATE_COLLEGE_COURSE_MAPPING_FAILURE';

export const UPDATE_COLLEGE_COURSE_MAPPING_START = 'UPDATE_COLLEGE_COURSE_MAPPING_START';
export const UPDATE_COLLEGE_COURSE_MAPPING_SUCCESS = 'UPDATE_COLLEGE_COURSE_MAPPING_SUCCESS';
export const UPDATE_COLLEGE_COURSE_MAPPING_FAILURE = 'UPDATE_COLLEGE_COURSE_MAPPING_FAILURE';

export const DELETE_COLLEGE_COURSE_MAPPING_START = 'DELETE_COLLEGE_COURSE_MAPPING_START';
export const DELETE_COLLEGE_COURSE_MAPPING_SUCCESS = 'DELETE_COLLEGE_COURSE_MAPPING_SUCCESS';
export const DELETE_COLLEGE_COURSE_MAPPING_FAILURE = 'DELETE_COLLEGE_COURSE_MAPPING_FAILURE';

export const FETCH_COLLEGE_COURSE_MAPPINGS_WITH_FILTERS = 'FETCH_COLLEGE_COURSE_MAPPINGS_WITH_FILTERS';
export const FETCH_COLLEGE_COURSE_MAPPINGS_SUCCESS = 'FETCH_COLLEGE_COURSE_MAPPINGS_SUCCESS';
export const FETCH_COLLEGE_COURSE_MAPPINGS_FAILURE = 'FETCH_COLLEGE_COURSE_MAPPINGS_FAILURE';
export const REFRESH_COLLEGE_COURSE_MAPPINGS = 'REFRESH_COLLEGE_COURSE_MAPPINGS';

// ================================SME COURSE MAPPING - ASYNC ================================ //
export const CREATE_SME_COURSE_MAPPING_START = 'CREATE_SME_COURSE_MAPPING_START';
export const CREATE_SME_COURSE_MAPPING_SUCCESS = 'CREATE_SME_COURSE_MAPPING_SUCCESS';
export const CREATE_SME_COURSE_MAPPING_FAILURE = 'CREATE_SME_COURSE_MAPPING_FAILURE';

export const DELETE_SME_COURSE_MAPPING_START = 'DELETE_SME_COURSE_MAPPING_START';
export const DELETE_SME_COURSE_MAPPING_SUCCESS = 'DELETE_SME_COURSE_MAPPING_SUCCESS';
export const DELETE_SME_COURSE_MAPPING_FAILURE = 'DELETE_SME_COURSE_MAPPING_FAILURE';

export const FETCH_SME_COURSE_MAPPINGS_WITH_FILTERS = 'FETCH_SME_COURSE_MAPPINGS_WITH_FILTERS';
export const FETCH_SME_COURSE_MAPPINGS_SUCCESS = 'FETCH_SME_COURSE_MAPPINGS_SUCCESS';
export const FETCH_SME_COURSE_MAPPINGS_FAILURE = 'FETCH_SME_COURSE_MAPPINGS_FAILURE';
export const REFRESH_SME_COURSE_MAPPINGS = 'REFRESH_SME_COURSE_MAPPINGS';

// ================================DEGREE CONFIGURATION - ASYNC ================================ //
export const CREATE_DEGREE_CONFIGURATION_START = 'CREATE_DEGREE_CONFIGURATION_START';
export const CREATE_DEGREE_CONFIGURATION_SUCCESS = 'CREATE_DEGREE_CONFIGURATION_SUCCESS';
export const CREATE_DEGREE_CONFIGURATION_FAILURE = 'CREATE_DEGREE_CONFIGURATION_FAILURE';

export const UPDATE_DEGREE_CONFIGURATION_START = 'UPDATE_DEGREE_CONFIGURATION_START';
export const UPDATE_DEGREE_CONFIGURATION_SUCCESS = 'UPDATE_DEGREE_CONFIGURATION_SUCCESS';
export const UPDATE_DEGREE_CONFIGURATION_FAILURE = 'UPDATE_DEGREE_CONFIGURATION_FAILURE';

export const DELETE_DEGREE_CONFIGURATION_START = 'DELETE_DEGREE_CONFIGURATION_START';
export const DELETE_DEGREE_CONFIGURATION_SUCCESS = 'DELETE_DEGREE_CONFIGURATION_SUCCESS';
export const DELETE_DEGREE_CONFIGURATION_FAILURE = 'DELETE_DEGREE_CONFIGURATION_FAILURE';

export const FETCH_DEGREE_CONFIGURATIONS_WITH_FILTERS = 'FETCH_DEGREE_CONFIGURATIONS_WITH_FILTERS';
export const FETCH_DEGREE_CONFIGURATIONS_SUCCESS = 'FETCH_DEGREE_CONFIGURATIONS_SUCCESS';
export const FETCH_DEGREE_CONFIGURATIONS_FAILURE = 'FETCH_DEGREE_CONFIGURATIONS_FAILURE';
export const REFRESH_DEGREE_CONFIGURATIONS = 'REFRESH_DEGREE_CONFIGURATIONS';

// ================================COURSE CATEGORIES - ASYNC ================================ //
export const CREATE_COURSE_CATEGORY_START = 'CREATE_COURSE_CATEGORY_START';
export const CREATE_COURSE_CATEGORY_SUCCESS = 'CREATE_COURSE_CATEGORY_SUCCESS';
export const CREATE_COURSE_CATEGORY_FAILURE = 'CREATE_COURSE_CATEGORY_FAILURE';

export const FETCH_COURSE_CATEGORIES_WITH_FILTERS = 'FETCH_COURSE_CATEGORIES_WITH_FILTERS';
export const FETCH_COURSE_CATEGORIES_SUCCESS = 'FETCH_COURSE_CATEGORIES_SUCCESS';
export const FETCH_COURSE_CATEGORIES_FAILURE = 'FETCH_COURSE_CATEGORIES_FAILURE';

// ================================COURSE PREREQUISITES - ASYNC ================================ //
export const FETCH_COURSE_PREREQUISITES_START = 'FETCH_COURSE_PREREQUISITES_START';
export const FETCH_COURSE_PREREQUISITES_SUCCESS = 'FETCH_COURSE_PREREQUISITES_SUCCESS';
export const FETCH_COURSE_PREREQUISITES_FAILURE = 'FETCH_COURSE_PREREQUISITES_FAILURE';

export const ADD_COURSE_PREREQUISITE_START = 'ADD_COURSE_PREREQUISITE_START';
export const ADD_COURSE_PREREQUISITE_SUCCESS = 'ADD_COURSE_PREREQUISITE_SUCCESS';
export const ADD_COURSE_PREREQUISITE_FAILURE = 'ADD_COURSE_PREREQUISITE_FAILURE';

export const REMOVE_COURSE_PREREQUISITE_START = 'REMOVE_COURSE_PREREQUISITE_START';
export const REMOVE_COURSE_PREREQUISITE_SUCCESS = 'REMOVE_COURSE_PREREQUISITE_SUCCESS';
export const REMOVE_COURSE_PREREQUISITE_FAILURE = 'REMOVE_COURSE_PREREQUISITE_FAILURE';

// ================================DASHBOARD - ASYNC ================================ //
export const FETCH_DASHBOARD_STATS_START = 'FETCH_DASHBOARD_STATS_START';
export const FETCH_DASHBOARD_STATS_SUCCESS = 'FETCH_DASHBOARD_STATS_SUCCESS';
export const FETCH_DASHBOARD_STATS_FAILURE = 'FETCH_DASHBOARD_STATS_FAILURE';

export const FETCH_SYSTEM_HEALTH_START = 'FETCH_SYSTEM_HEALTH_START';
export const FETCH_SYSTEM_HEALTH_SUCCESS = 'FETCH_SYSTEM_HEALTH_SUCCESS';
export const FETCH_SYSTEM_HEALTH_FAILURE = 'FETCH_SYSTEM_HEALTH_FAILURE';


// College Degree Mapping Actions
export const FETCH_COLLEGE_DEGREE_MAPPINGS_START = 'FETCH_COLLEGE_DEGREE_MAPPINGS_START';
export const FETCH_COLLEGE_DEGREE_MAPPINGS_SUCCESS = 'FETCH_COLLEGE_DEGREE_MAPPINGS_SUCCESS';
export const FETCH_COLLEGE_DEGREE_MAPPINGS_FAILURE = 'FETCH_COLLEGE_DEGREE_MAPPINGS_FAILURE';

export const CREATE_COLLEGE_DEGREE_MAPPING_START = 'CREATE_COLLEGE_DEGREE_MAPPING_START';
export const CREATE_COLLEGE_DEGREE_MAPPING_SUCCESS = 'CREATE_COLLEGE_DEGREE_MAPPING_SUCCESS';
export const CREATE_COLLEGE_DEGREE_MAPPING_FAILURE = 'CREATE_COLLEGE_DEGREE_MAPPING_FAILURE';

export const UPDATE_COLLEGE_DEGREE_MAPPING_START = 'UPDATE_COLLEGE_DEGREE_MAPPING_START';
export const UPDATE_COLLEGE_DEGREE_MAPPING_SUCCESS = 'UPDATE_COLLEGE_DEGREE_MAPPING_SUCCESS';
export const UPDATE_COLLEGE_DEGREE_MAPPING_FAILURE = 'UPDATE_COLLEGE_DEGREE_MAPPING_FAILURE';

export const DELETE_COLLEGE_DEGREE_MAPPING_START = 'DELETE_COLLEGE_DEGREE_MAPPING_START';
export const DELETE_COLLEGE_DEGREE_MAPPING_SUCCESS = 'DELETE_COLLEGE_DEGREE_MAPPING_SUCCESS';
export const DELETE_COLLEGE_DEGREE_MAPPING_FAILURE = 'DELETE_COLLEGE_DEGREE_MAPPING_FAILURE';


// ===============================Get Degrees by college ================================ //

export const FETCH_COLLEGE_DEGREES_START = 'FETCH_COLLEGE_DEGREES_START';
export const FETCH_COLLEGE_DEGREES_SUCCESS = 'FETCH_COLLEGE_DEGREES_SUCCESS';  
export const FETCH_COLLEGE_DEGREES_FAILURE = 'FETCH_COLLEGE_DEGREES_FAILURE';
export const CLEAR_COLLEGE_DEGREES = 'CLEAR_COLLEGE_DEGREES';

// ================================LEGACY SYNC ACTIONS ================================ //
export const ADD_COLLEGE_COURSE_MAPPING = 'ADD_COLLEGE_COURSE_MAPPING';
export const UPDATE_COLLEGE_COURSE_MAPPING = 'UPDATE_COLLEGE_COURSE_MAPPING';
export const DELETE_COLLEGE_COURSE_MAPPING = 'DELETE_COLLEGE_COURSE_MAPPING';

export const ADD_SME_COURSE_MAPPING = 'ADD_SME_COURSE_MAPPING';
export const UPDATE_SME_COURSE_MAPPING = 'UPDATE_SME_COURSE_MAPPING';
export const DELETE_SME_COURSE_MAPPING = 'DELETE_SME_COURSE_MAPPING';

export const ADD_DEGREE_COURSE_MAPPING = 'ADD_DEGREE_COURSE_MAPPING';
export const UPDATE_DEGREE_COURSE_MAPPING = 'UPDATE_DEGREE_COURSE_MAPPING';
export const DELETE_DEGREE_COURSE_MAPPING = 'DELETE_DEGREE_COURSE_MAPPING';

export const ADD_LANGUAGE_COURSE_MAPPING = 'ADD_LANGUAGE_COURSE_MAPPING';
export const UPDATE_LANGUAGE_COURSE_MAPPING = 'UPDATE_LANGUAGE_COURSE_MAPPING';
export const DELETE_LANGUAGE_COURSE_MAPPING = 'DELETE_LANGUAGE_COURSE_MAPPING';

// ================================UI STATE ================================ //
export const SET_LOADING = 'SET_LOADING';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_FILTERS = 'SET_FILTERS';
export const RESET_OPERATIONS_STATE = 'RESET_OPERATIONS_STATE';

// ================================SEMESTER PROMOTION ================================ //
export const PROMOTE_SEMESTER_START = 'PROMOTE_SEMESTER_START';
export const PROMOTE_SEMESTER_SUCCESS = 'PROMOTE_SEMESTER_SUCCESS';
export const PROMOTE_SEMESTER_FAILURE = 'PROMOTE_SEMESTER_FAILURE';
export const CLEAR_PROMOTION_RESULT = 'CLEAR_PROMOTION_RESULT';
export const PREVIEW_SEMESTER_START = 'PREVIEW_SEMESTER_START';
export const PREVIEW_SEMESTER_SUCCESS = 'PREVIEW_SEMESTER_SUCCESS';
export const PREVIEW_SEMESTER_FAILURE = 'PREVIEW_SEMESTER_FAILURE';
export const CLEAR_SEMESTER_PREVIEW = 'CLEAR_SEMESTER_PREVIEW';